import { setupI18n } from '@lingui/core';
// @ts-ignore
import catalogEn from '../locale/en/messages';
import { Languages } from '../types/enums';

export const catalogs = { [Languages.EN]: catalogEn };

export const i18n = setupI18n({
    language: Languages.EN,
    catalogs: catalogs,
});
